import * as React from 'react';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { PriceDisclaimer } from './PriceDisclaimer.js';

const PriceDisclaimerContainer = ()=>{
    const { isPriceDisclaimerEnabled  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    return isPriceDisclaimerEnabled ? /*#__PURE__*/ React.createElement(PriceDisclaimer, {
        text: getLabel('products.price.disclaimer')
    }) : null;
};

export { PriceDisclaimerContainer };
//# sourceMappingURL=PriceDisclaimerContainer.js.map
